import { AgendaMesDia } from '../../../interfaces/agenda';
import { dataLocal } from './agenda-filtro';

export type StatusDiaMes = 'disp' | 'parc' | 'bloq' | 'lot' | 'sem';

export interface AgendaCelulaMes {
  /** yyyy-MM-dd. */
  data: string;
  /** Dia do mês (1-31), só para exibir — evita conta no template. */
  numeroDia: number;
  foraDoMes: boolean;
  hoje: boolean;
  /** Null = sem regra gerada (back não devolveu o dia). */
  dia: AgendaMesDia | null;
  status: StatusDiaMes;
  rotuloStatus: string;
  /** 0-100, para a barrinha de ocupação. */
  percentualOcupacao: number;
}

const ROTULO_STATUS: Record<StatusDiaMes, string> = {
  disp: 'Disponível', parc: 'Bloqueio parcial', bloq: 'Bloqueado', lot: 'Lotado', sem: 'Sem regra',
};

/**
 * O back já agrega bloqueio total/parcial e livres por dia (month-summary); aqui só decide a
 * prioridade visual, igual ao original: bloqueado > lotado > bloqueio parcial > disponível.
 */
export function statusMes(dia: AgendaMesDia | null): StatusDiaMes {
  if (!dia || !dia.total) return 'sem';
  if (dia.bloqueioTotal) return 'bloq';
  if (dia.livres === 0) return 'lot';
  if (dia.bloqueioParcial) return 'parc';
  return 'disp';
}

/**
 * Calendário 6x7 (42 células) a partir do primeiro domingo antes (ou igual a) do dia 1 do mês.
 * Dias de outro mês vêm esmaecidos mas clicáveis.
 */
export function celulasMes(mes: string, dias: AgendaMesDia[], hoje: string): AgendaCelulaMes[] {
  const [ano, m] = mes.split('-').map(Number);
  const primeiroDia = new Date(ano, m - 1, 1);
  const inicio = new Date(ano, m - 1, 1 - primeiroDia.getDay());
  const porData = new Map(dias.map(d => [d.dtDia, d]));
  const celulas: AgendaCelulaMes[] = [];
  for (let i = 0; i < 42; i++) {
    const d = new Date(inicio.getFullYear(), inicio.getMonth(), inicio.getDate() + i);
    const ds = dataLocal(d);
    const dia = porData.get(ds) ?? null;
    const status = statusMes(dia);
    celulas.push({
      data: ds,
      numeroDia: d.getDate(),
      foraDoMes: d.getMonth() !== m - 1,
      hoje: ds === hoje,
      dia,
      status,
      rotuloStatus: ROTULO_STATUS[status],
      percentualOcupacao: dia && dia.total ? Math.min(100, Math.round((dia.ocupados / dia.total) * 100)) : 0,
    });
  }
  return celulas;
}

export function mesAnterior(mes: string): string {
  const [ano, m] = mes.split('-').map(Number);
  const d = new Date(ano, m - 2, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export function mesSeguinte(mes: string): string {
  const [ano, m] = mes.split('-').map(Number);
  const d = new Date(ano, m, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

const MESES = [
  'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
  'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro',
];

export function rotuloMes(mes: string): string {
  const [ano, m] = mes.split('-').map(Number);
  return `${MESES[m - 1]} ${ano}`;
}
